import React from "react";
import "./SectionTwo.scss";

const isKorean = () => {
  const lang =
    (typeof localStorage !== "undefined" && localStorage.getItem("i18nextLng")) || "en";
  return lang === "kr" || lang.startsWith("ko");
};

const KEYWORDS = ["3D VISUALIZATION", "BIM · DIGITAL TWIN", "SMART CITY", "VFX · MEDIA"];

function SectionTwo() {
  const kr = isKorean();

  return (
    <div className="section-two">
      {/* ── ambient 3D background ── */}
      <div className="s2-stage">
        <div className="s2-cube">
          <span className="s2-cube__face s2-cube__face--front" />
          <span className="s2-cube__face s2-cube__face--back" />
          <span className="s2-cube__face s2-cube__face--right" />
          <span className="s2-cube__face s2-cube__face--left" />
          <span className="s2-cube__face s2-cube__face--top" />
          <span className="s2-cube__face s2-cube__face--bottom" />
        </div>
      </div>
      <div className="s2-floor" />

      {/* ── statement ── */}
      <div className="section-two-inner">
        <div className="section-two-slogan">
          <span className="s2-eyebrow">CONCEPT CUBE — 3D STUDIO</span>
          <h2 className="s2-headline">
            We model the world
            <br />
            before it&apos;s <span className="s2-accent">built</span>.
          </h2>
        </div>

        <div className="section-two-swiper s2-sub">
          <p className="s2-lead">
            {kr
              ? "BIM · Revit · CAD 기반의 3D 비주얼라이제이션 · 디지털 트윈 · 미디어 콘텐츠 전문 스튜디오"
              : "A 3D visualization, digital-twin & media studio — built on BIM, Revit and CAD."}
          </p>
          <div className="s2-keys">
            {KEYWORDS.map((k, i) => (
              <React.Fragment key={k}>
                {i > 0 && <span className="s2-keys__dot" />}
                <span className="s2-keys__item">{k}</span>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionTwo;
